import React from 'react';
import Chip from '@material-ui/core/Chip';
import PPMobileCardView from '../../../../../components/PPMobileCardView';

// Same labels and colours as the desktop "Due (In Days)" column
const dueStatus = (dueDays) => {
    if (dueDays === 1) return { label: "Due in 1 day", color: '#4caf50' };
    if (dueDays === -1) return { label: "Over due by 1 day", color: '#f44336' };
    if (dueDays > 0) return { label: "Due in " + dueDays + " days", color: '#4caf50' };
    if (dueDays < 0) return { label: "Over due by " + Math.abs(dueDays) + " days", color: '#f44336' };
    return { label: "Today", color: '#ff9800' };
};

const Mobile = ({ data, onDelete, onEdit, onCompletedVaccination }) => {
    const due = dueStatus(data.dueDays);

    const rows = [
        { label: 'Due', value: <Chip className="pp-pill" label={due.label} style={{ backgroundColor: due.color, color: 'white' }} />, inHeader: true, hideLabel: true },
        { label: 'Batch Name', value: data.batchName },
        { label: 'Details', value: data.vaccineName, fullWidth: true },
    ];

    // Edit/Delete only for manually added reminders, same as desktop
    const menuItems = data.vaccinationType !== 1 ?
        [
            { label: 'Vaccinated Date', onClick: onCompletedVaccination },
        ] : [
            { label: 'Vaccinated Date', onClick: onCompletedVaccination },
            { label: 'Edit', onClick: onEdit },
            { label: 'Delete', onClick: onDelete },
        ];

    return (
        <PPMobileCardView
            title={data.shedName}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
